<template>
  <div class="notification-dropdown">
    <el-menu
      class="tabs"
      mode="horizontal"
      :value="currentTab"
      @select="onTabChange"
    >
      <el-menu-item index="notifications">
        {{ $t('NOTIFICATIONS') }}
      </el-menu-item>
      <el-menu-item
        v-if="$featureOn('tasks-notifications')"
        index="tasks"
      >
        {{ !tasksNotifications.length ? $t('TASKS') : $t('TASKS ({count})', { count: tasksNotifications.length }) }}
      </el-menu-item>
      <el-menu-item
        class="configuration-tab"
        index="configuration"
      >
        <el-icon
          color="fixed-primary"
          name="cog-o"
          variant="24"
        />
      </el-menu-item>
    </el-menu>
    <div v-if="showPopper">
      <notification-settings v-if="currentTab === 'configuration'" />
      <notifications-list
        v-else-if="currentTab === 'notifications'"
        :notifications="mainNotifications"
        :currentTab="currentTab"
      />
      <notifications-list
        v-else-if="$featureOn('tasks-notifications') && currentTab === 'tasks'"
        :filterPanel="false"
        :notifications="tasksNotifications"
        :currentTab="currentTab"
      />
    </div>
  </div>
</template>

<script>
  import NotificationSettings from '@/common/components/notification-center/NotificationSettings.vue';
  import NotificationsList from '@/common/components/notification-center/NotificationsList.vue';

  export default {
    name: 'NotificationDropdown',
    components: {
      NotificationSettings,
      NotificationsList
    },
    props: {
      showPopper: {
        type: Boolean,
        default: true,
      }
    },
    data() {
      return {
        currentTab: 'notifications',
      };
    },
    computed: {
      tasksNotifications() {
        return this.$store.getters['notifications/tasksNotifications'];
      },
      mainNotifications() {
        return this.$store.getters['notifications/mainNotifications'];
      }
    },
    methods: {
      onTabChange(tab) {
        this.currentTab = tab;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .notification-dropdown {
    display: flex;
    flex-flow: column;
    max-height: 100%;
    width: 100%;

    > * {
      max-height: 100%;
      min-height: 0;
    }
  }

  .tabs {
    flex: 0 0 auto;
    box-shadow: 0 -1px 0 0 $av-brand-accent inset;
  }

  .configuration-tab {
    margin-left: auto !important;
  }
</style>
